import React, { FC } from "react";
import { Link } from "react-router-dom";

import { careerReferencePath } from "../../store/student";
import MapActionButtons from "../../organisms/Career/MapActionButtons";
import { ReactComponent as Logo } from "../../assets/images/Career/logo.svg";

import styles from "./Career.module.scss";

type Props = {
  createCareerSheets: () => void;
};

const Career: FC<Props> = ({ createCareerSheets }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.hero}>
        <Logo className={styles.logo} />
        <div className={styles.title}>
          <p className={styles.main}>
            GEARキャリア
            <br className={styles.isSp} />
            開拓モードにようこそ！
          </p>
          <p className={styles.sub}>
            GEARがあなたのキャリア開拓の
            <br className={styles.isSp} />
            お手伝いをします。
          </p>
        </div>
      </div>
      <div className={styles.actionButtons}>
        <MapActionButtons createCareerSheets={createCareerSheets} />
      </div>
      <Link to={careerReferencePath} className={styles.reference}>
        キャリア開拓モードとは？
      </Link>
    </div>
  );
};

export default Career;
